var _style, _circle, _path, _g, _polygon, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 490,
    height: 490,
    xlinkHref: "899BE000.png",
    transform: "matrix(0.24 0 0 0.24 1.8 16.68)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -127.5381,
    y1: -64.3501,
    x2: -74.3924,
    y2: -11.2044,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.7,
    cy: 68.6,
    r: 43.7
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.4615,
    y1: -58.997,
    x2: -99.3356,
    y2: -51.6687,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.3482 181.3146)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6FC1AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55BEC0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.6,90.3L116,68.7c-2.2-2.2-5.7-2.5-8.1-0.5c-1.3,1.2-2,2.8-2,4.4c0,1.5,0.6,3,1.7,4.1L120.8,90l-54,0 c-10,6.1-23.4,4.6-31.7-4.6C26.6,76,26.4,61.6,34.7,52c0,0,0,0,0,0l-6.5-6.5c-5.6,6.2-9.1,14.5-9,23.6 c0.1,19.2,16.1,34.6,35.3,34.6l64.5,0l-11.5,11.5c-2.3,2.3-2.3,6.1,0.1,8.4c2.3,2.1,6.1,1.9,8.3-0.3l21.6-21.6 C140.8,98.5,140.8,93.5,137.6,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 335,
    height: 336,
    xlinkHref: "899BE001.png",
    transform: "matrix(0.24 0 0 0.24 20.52 35.16)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 53.7,
    cy: 68.5,
    r: 25.2
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.6384,
    y1: 59.579,
    x2: 69.697,
    y2: 85.6377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "58,60.2 58,57.6 61.4,57.6 60.5,56 61.4,54.2 57.5,54.2 57.5,54.2 57,54.2 57,60.2 52.5,66.6  47.7,63.2 37.9,77 70.3,77  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.5,
    y1: 75,
    x2: 147.5,
    y2: 75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55BEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C728A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75,147.5C35,147.5,2.5,115,2.5,75C2.5,35,35,2.5,75,2.5c40,0,72.5,32.5,72.5,72.5 C147.5,115,115,147.5,75,147.5z M75,5.3C36.6,5.3,5.3,36.6,5.3,75c0,38.4,31.2,69.7,69.7,69.7c38.4,0,69.7-31.2,69.7-69.7 C144.7,36.6,113.4,5.3,75,5.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMision);
export default __webpack_public_path__ + "static/media/mision.a06de19ee287dc599e3bca6ec996e95a.svg";
export { ForwardRef as ReactComponent };